/*jshint esversion: 6 */
import Vue from 'vue';
import axios from 'axios';
import router from '@/router/index';
import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
    show_calendar_weeks: false,
    working_time: {
      start: 0,
      duration: 86340
    }
});

// State object
const state = initialState();
// Getter functions
const getters = {
  //local variables
  isShowCalendarWeeks: (state) => state.show_calendar_weeks,
  //local helpers
  getCalendarWeek: (state, getters) => (date) => {
    var tdt = getters.getNewDate(date.valueOf());
    var dayn = (date.getDay() + 6) % 7;
    tdt.setDate(tdt.getDate() - dayn + 3);
    var firstThursday = tdt.valueOf();
    tdt.setMonth(0, 1);
    if (tdt.getDay() !== 4)
    {
      tdt.setMonth(0, 1 + ((4 - tdt.getDay()) + 7) % 7);
    }
    return 1 + Math.ceil((firstThursday - tdt) / 604800000);
  },
  getNewDate: () => (date) => {
    if (typeof date === 'string') {
      let date_string = date.replace(/-/g, "/");
      return new Date(date_string);
    } else {
      return new Date(date);
    }
  },
  //calendar getters in Ultra Store
  hasCalendar: (state, getters, rootState) => (id) => {
    if (rootState.Ultra.projects[id].calendar_project_start !== '' &&
        rootState.Ultra.projects[id].calendar_first_day_of_week !== '' &&
        rootState.Ultra.projects[id].takt_time_value > 0
    ) {
      return true;
    }
    return false;
  },
  getCalendar: (state, getters, rootState, rootGetters) => (id) => {
    //Check if all variables are set
    let calendar = {takt_times: [], months: []};
    if (rootState.Ultra.projects[id].calendar_project_start !== '' &&
        rootState.Ultra.projects[id].calendar_first_day_of_week !== '' &&
        rootState.Ultra.projects[id].takt_time_value > 0
    ) {
    let current_date = getters.getNewDate(rootState.Ultra.projects[id].calendar_project_start);
    // let current_date = new Date(rootState.Ultra.projects[id].calendar_project_start);
    // let takt_count = 1;
    let project_duration = rootGetters['Project/getProjectLength'](id);
    // let first_day_of_week = getters.getFirstDayOfWeekInteger(id);
    let collision_weeks = getters.getCollisionWeeks(id);
    //every takttime
    for (var i = 0; i < project_duration; i++) {
      //check if regular week
      calendar.takt_times.push({
        dates: [],
      });
        while (calendar.takt_times[i].dates.length < rootState.Ultra.projects[id].takt_time_value) {
          if (collision_weeks.find(week =>
            getters.getNewDate(week.first_day).getTime() <= current_date.getTime() &&
            getters.getNewDate(week.last_day).getTime() >= current_date.getTime()
            )) {
              let collision_week = collision_weeks.find(week =>
                getters.getNewDate(week.first_day).getTime() <= current_date.getTime() &&
                getters.getNewDate(week.last_day).getTime() >= current_date.getTime()
              );
            //irregular week
            if (collision_week.week.find(day => day.date.substring(0, 10) === current_date.toISOString().substring(0, 10)).selected === true) {
              calendar.takt_times[i].dates.push(getters.getNewDate(current_date));
            }
            current_date.setDate(current_date.getDate() + 1);
            current_date = getters.getNewDate(`${current_date.toISOString().substring(0,10)} 12:00:00 UTC`);
            //break
            if (getters.getNewDate(collision_week.last_day).getTime() < current_date.getTime() && calendar.takt_times[i].dates.length !== 0) {
                break;
            }
          } else {
          if (rootState.Ultra.projects[id][`calendar_selected_takt_start_week_days_${rootState.Ultra.week_days[current_date.getDay()].toLowerCase()}`] ||
              rootState.Ultra.projects[id][`calendar_blocked_takt_start_week_days_${rootState.Ultra.week_days[current_date.getDay()].toLowerCase()}`]
              ) {
            calendar.takt_times[i].dates.push(getters.getNewDate(current_date));
          }
          current_date.setDate(current_date.getDate() + 1);
          current_date = getters.getNewDate(`${current_date.toISOString().substring(0,10)} 12:00:00 UTC`);

        }
      }
      // initialize calendar weeks
      calendar.takt_times[i].calendar_weeks = [];
      if (calendar.takt_times[i].dates.length !== 0) {
        //First Takt Day
        calendar.takt_times[i].first_day_string = `${rootState.Ultra.week_days[calendar.takt_times[i].dates[0].getDay()]} ${calendar.takt_times[i].dates[0].toISOString().substring(8, 10)}`;
        //last Takt day
        calendar.takt_times[i].last_day_string = `${rootState.Ultra.week_days[calendar.takt_times[i].dates[calendar.takt_times[i].dates.length-1].getDay()]} ${calendar.takt_times[i].dates[calendar.takt_times[i].dates.length-1].toISOString().substring(8, 10)}`;
        // week first date
        calendar.takt_times[i].week_first_date = getters.getNewDate(calendar.takt_times[i].dates[0]);
        calendar.takt_times[i].week_first_date.setDate(calendar.takt_times[i].dates[0].getDate() - getters.getWeekDaysSorted(id).findIndex(day => day === rootState.Ultra.week_days[calendar.takt_times[i].dates[0].getDay()]));
        calendar.takt_times[i].week_first_date = getters.getNewDate(`${calendar.takt_times[i].week_first_date.toISOString().substring(0,10)} 12:00:00 UTC`);

        //week last date
        calendar.takt_times[i].week_last_date = getters.getNewDate(calendar.takt_times[i].week_first_date);
        calendar.takt_times[i].week_last_date.setDate(calendar.takt_times[i].week_first_date.getDate() + 6);
        calendar.takt_times[i].week_last_date = getters.getNewDate(`${calendar.takt_times[i].week_last_date.toISOString().substring(0,10)} 12:00:00 UTC`);
        //calendar weeks
        calendar.takt_times[i].calendar_weeks.push(getters.getCalendarWeek(calendar.takt_times[i].dates[0]));
        if (getters.getCalendarWeek(calendar.takt_times[i].dates[0]) !== getters.getCalendarWeek(calendar.takt_times[i].dates[calendar.takt_times[i].dates.length-1])) {
          calendar.takt_times[i].calendar_weeks.push(getters.getCalendarWeek(calendar.takt_times[i].dates[calendar.takt_times[i].dates.length-1]));
        }
      }
      // if month not exists
      if (!calendar.months.find(month => month.year === calendar.takt_times[i].dates[0].getFullYear() &&
                                month.integer === calendar.takt_times[i].dates[0].getMonth())) {
        calendar.months.push({
          year: calendar.takt_times[i].dates[0].getFullYear(),
          integer: calendar.takt_times[i].dates[0].getMonth(),
          name: rootState.Ultra.months[calendar.takt_times[i].dates[0].getMonth()] + " '" + calendar.takt_times[i].dates[0].getFullYear().toString().substring(2,4),
          duration: 0,
          takt_index: i,
        });
      }
      // if full takt
      if (calendar.takt_times[i].dates[0].getMonth() === calendar.takt_times[i].dates[calendar.takt_times[i].dates.length-1].getMonth()) {
        calendar.months.find(month => month.year === calendar.takt_times[i].dates[0].getFullYear() &&
                              month.integer === calendar.takt_times[i].dates[0].getMonth()).duration += 1;
      } else {
        // if two months in takt
        for (let j = 1; j < calendar.takt_times[i].dates.length; j++) {
          if (calendar.takt_times[i].dates[j].getMonth() !== calendar.takt_times[i].dates[j-1].getMonth()) {
            calendar.months.find(month => month.year === calendar.takt_times[i].dates[j-1].getFullYear() &&
                                  month.integer === calendar.takt_times[i].dates[j-1].getMonth()).duration += j/calendar.takt_times[i].dates.length;
            calendar.months.push({
              year: calendar.takt_times[i].dates[j].getFullYear(),
              integer: calendar.takt_times[i].dates[j].getMonth(),
              name: rootState.Ultra.months[calendar.takt_times[i].dates[j].getMonth()] + " '" + calendar.takt_times[i].dates[j].getFullYear().toString().substring(2,4),
              duration: 1 - (j/calendar.takt_times[i].dates.length),
              takt_index: i,
            });
          }
        }
      }
    }
  }
    return calendar;
  },
  getCollisionWeeks: (state, getters, rootState) => (id) => {
    let week_array = [];
    let week_days = rootState.Ultra.week_days;
    for (let i = 0; i < rootState.Ultra.projects[id].collision_weeks.length; i++) {
      let collision_week = rootState.Ultra.projects[id].collision_weeks[i];
      let first_day = collision_week.first_day;
      let last_day = getters.getNewDate(first_day);
      last_day.setDate(last_day.getDate() + 6);
      last_day = last_day.toISOString().substring(0, 10) + " 12:00:00 UTC";
      let week = [];
      for (let i = 0; i < week_days.length; i++) {
        let j = getters.getFirstDayOfWeekInteger(id) + i;
        if (j > week_days.length-1) {
          j = j - week_days.length;
        }
        let current_date = getters.getNewDate(first_day);
        current_date.setDate(current_date.getDate() + i);
        current_date = current_date.toISOString().substring(0, 10) + " 12:00:00 UTC";
        let selected = false;
        let free_day = false;
        if (rootState.Ultra.projects[id].free_days.find(day => day.date === current_date)) {
          free_day = true;
        }
        if (collision_week[`collision_week_selected_${week_days[j].toLowerCase()}`]) {
          selected = true;
        }
        week.push({
          name: week_days[j],
          date: current_date,
          selected: selected,
          free_day: free_day,
        });
      }
      //check if is full takt
      let full_takt_count = Math.floor(week.filter(day => day.selected).length / rootState.Ultra.projects[id].takt_time_value);
      let takt = 1;
      let takt_count = 1;
      let color = '';
      for (let i = 0; i < week.length; i++) {
        color = '';
        if (week[i].selected) {
          if (takt <= full_takt_count) {
            color = 'blue';
          } else {
            color = 'orange';
          }
          if (takt_count !== 1) {
            color = color + ' lighten-3';
          }
          if (takt_count !== rootState.Ultra.projects[id].takt_time_value) {
            takt_count++;
          } else {
            takt_count = 1;
            takt++;
          }
        }
        week[i].color = color;
      }

      week_array.push({
        first_day: first_day,
        last_day: last_day,
        week: week,
      });
    }
    return week_array;
  },
  getFirstDayOfWeekInteger: (state, getters, rootState) => (id) => {
    return rootState.Ultra.week_days.indexOf(rootState.Ultra.projects[id].calendar_first_day_of_week);
  },
  getCurrentDayIndex: (state, getters, rootState) => (id) => {
    // let today = getters.getNewDate();
    let today = new Date();
    return getters.getWeekDaysSorted(id).indexOf(rootState.Ultra.week_days[today.getDay()]);
  },
  getCurrentTaktIndex: (state, getters, rootState) => (id) => {
    if (rootState.Ultra.projects[id].calendar_project_start !== '' &&
        rootState.Ultra.projects[id].calendar_first_day_of_week !== '' &&
        rootState.Ultra.projects[id].takt_time_value > 0 &&
        rootState.Ultra.projects[id].trains.length !== 0
    ) {
    // let today = getters.getNewDate(getters.getNewDate().toISOString().substring(0, 10) + ' 12:00:00 UTC');
    let today = getters.getNewDate(new Date().toISOString().substring(0, 10) + ' 12:00:00 UTC');
    let takt_times = getters.getCalendar(id).takt_times;
    let index = false;
    if (today.getTime() >= takt_times[0].week_first_date.getTime() &&
        today.getTime() <= takt_times[takt_times.length-1].week_last_date.getTime()) {
      for (let i = 0; i < takt_times.length; i++) {
        if (today.getTime() >= takt_times[i].week_first_date.getTime() &&
            today.getTime() <= takt_times[i].week_last_date.getTime()) {
              index = i;
              if (takt_times[i].dates.find(date => date.toISOString().substring(0, 10) === today.toISOString().substring(0, 10))) {
                break;
              }
              if (takt_times[i].dates[takt_times[i].dates.length-1].getTime() > today.getTime()) {
                break;
              }
        }
        if (index === false) {
          for (let i = 0; i < takt_times.length; i++) {
            if (today.getTime() < takt_times[i].week_first_date.getTime()) {
              index = -i;
              break;
            }
          }
        }
      }
    }
    return index;
  } else {
    return false;
  }
  },
  getFreeDays: (state, getters, rootState) => (id) => {
    let array = [];
    for (let i = 0; i < rootState.Ultra.projects[id].free_days.length; i++) {
      array.push(rootState.Ultra.projects[id].free_days[i].date.substring(0, 10));
    }
    array = array.sort();
    return array;
  },
  getRegularWeek: (state, getters, rootState) => (id) => {
    let week_array = [];
    let week_days_sorted = getters.getWeekDaysSorted(id);
    for (let j = 0; j < week_days_sorted.length; j++) {

      let selected = false;
      let blocked = false;
      let color = '';
      if (rootState.Ultra.projects[id][`calendar_selected_takt_start_week_days_${week_days_sorted[j].toLowerCase()}`]) {
        selected = true;
        color = 'blue';
      } else if (rootState.Ultra.projects[id][`calendar_blocked_takt_start_week_days_${week_days_sorted[j].toLowerCase()}`]) {
        blocked = true;
        color = "blue lighten-3";
      }
      week_array.push({
        name: week_days_sorted[j],
        selected: selected,
        blocked: blocked,
        color: color,
      });
    }
    return week_array;
  },
  getDateFromTaktIndex: (state, getters) => (payload) => {
    if (payload.chronology === 'before') {
      let dates = getters.getCalendar(payload.project_id).takt_times[payload.takt_index].dates;
      return dates[0];
    } else {
      let dates = getters.getCalendar(payload.project_id).takt_times[payload.takt_index-1].dates;
      return dates[dates.length-1];
    }
  },
  getDatesFromTaktIndex: (state, getters) => (payload) => {
    if (payload.chronology === 'before') {
      let dates = getters.getCalendar(payload.project_id).takt_times[payload.takt_index].dates;
      return dates;
    } else {
      let dates = getters.getCalendar(payload.project_id).takt_times[payload.takt_index-1].dates;
      return dates;
    }
  },
  getTaktIndexFromDate: (state, getters) => (payload) => {
    let takt_index = {
      index: -1,
      position: 0,
      takt_length: 0,
    };
    let takt_times = getters.getCalendar(payload.project_id).takt_times;
    let requested_date = new Date(payload.date_string);
    takt_times:
    for (let i = 0; i < takt_times.length; i++) {
      for (let j = 0; j < takt_times[i].dates.length; j++) {
        let date = takt_times[i].dates[j];
          if (payload.date_string === `${date.getFullYear()}-${date.getMonth()+1<10?0:''}${date.getMonth()+1}-${date.getDate()<10?0:''}${date.getDate()}`) {
          takt_index.index = i;
          takt_index.position = j + 1;
          takt_index.takt_length = takt_times[i].dates.length;
          break takt_times;
          }
          else if (requested_date.getTime() < date.getTime()) {
            takt_index.index = i;
            takt_index.position = j;
            takt_index.takt_length = takt_times[i].dates.length;
            break takt_times;
          }
      }
    }
    if(takt_index.index === -1){
      return {
        index: takt_times.length,
        position: takt_times[takt_times.length - 1].dates.length,
        takt_length: takt_times[takt_times.length - 1].dates.length,
      }
    }
    return takt_index;
  },
  getWeekDaysSorted: (state, getters, rootState) => (id) => {
    let week_days = rootState.Ultra.week_days;
    let week_days_sorted = [];
    for (let i = 0; i < week_days.length; i++) {
      let j = getters.getFirstDayOfWeekInteger(id) + i;
      if (j > week_days.length-1) {
        j = j - week_days.length;
      }
      week_days_sorted.push(week_days[j]);
    }
    return week_days_sorted;
  },
  //Project Getters in UltraStore: deprecated -> use mapState in component
  getMonths: (state, getters, rootState) => {
    return rootState.Ultra.months;
  },
  getFirstDayOfWeek: (state, getters, rootState) => (id) => {
    return rootState.Ultra.projects[id].calendar_first_day_of_week;
  },
  getWeekDays: (state, getters, rootState) => {
    return rootState.Ultra.week_days;
  },
  getGridSections: (state, getters, rootState, rootGetters) => (project_id) => {
    const sections = rootGetters['Ultra/getUObjects']({ids: rootState.Ultra.projects[project_id].gridsections, type: 'gridsections'})
    sections.sort((a,b) => a.start - b.start);
    return sections;
  },
  getWorkingDays: (state, getters) => (payload) => {
    let dates = getters.getCalendar(payload.project_id).takt_times[payload.takt_index].dates;
    let working_days = [];
    dates.forEach((day, index) => {
      working_days.push({value: index, text: day.toString().substring(0,3)})
    });
    // console.log(working_days)
    return working_days
  }
};
// Actions
const actions = {
  // with no mutation
  setCalendar({commit, getters, rootState}, id) {
    let project = rootState.Ultra.projects[id];
    let calendar_data = {
      // calendar Data
      takt_time_value: project.takt_time_value,
      calendar_first_day_of_week: project.calendar_first_day_of_week,
      calendar_project_start: project.calendar_project_start,
      calendar_selected_takt_start_week_days_mo: project.calendar_selected_takt_start_week_days_mo,
      calendar_selected_takt_start_week_days_tu: project.calendar_selected_takt_start_week_days_tu,
      calendar_selected_takt_start_week_days_we: project.calendar_selected_takt_start_week_days_we,
      calendar_selected_takt_start_week_days_th: project.calendar_selected_takt_start_week_days_th,
      calendar_selected_takt_start_week_days_fr: project.calendar_selected_takt_start_week_days_fr,
      calendar_selected_takt_start_week_days_sa: project.calendar_selected_takt_start_week_days_sa,
      calendar_selected_takt_start_week_days_su: project.calendar_selected_takt_start_week_days_su,
      calendar_blocked_takt_start_week_days_mo: project.calendar_blocked_takt_start_week_days_mo,
      calendar_blocked_takt_start_week_days_tu: project.calendar_blocked_takt_start_week_days_tu,
      calendar_blocked_takt_start_week_days_we: project.calendar_blocked_takt_start_week_days_we,
      calendar_blocked_takt_start_week_days_th: project.calendar_blocked_takt_start_week_days_th,
      calendar_blocked_takt_start_week_days_fr: project.calendar_blocked_takt_start_week_days_fr,
      calendar_blocked_takt_start_week_days_sa: project.calendar_blocked_takt_start_week_days_sa,
      calendar_blocked_takt_start_week_days_su: project.calendar_blocked_takt_start_week_days_su,
      // free_days: []
      edit_key: rootState.Project.edit_key,
    };
    //Freedays
    let free_day_data = {
      free_days: [],
      edit_key: rootState.Project.edit_key,
    };
    for (let i = 0; i < project.free_days.length; i++) {
      free_day_data.free_days.push({
        date: project.free_days[i].date
      });
    }
    //Collision Weeks
    let collision_week_data = {
      collision_weeks: [],
      edit_key: rootState.Project.edit_key,
    };
    let collision_weeks = getters.getCollisionWeeks(id);
    for (let i = 0; i < collision_weeks.length; i++) {
      let selected = [];
      for (let j = 0; j < collision_weeks[i].week.length; j++) {
        if (collision_weeks[i].week[j].selected) {
          selected.push(collision_weeks[i].week[j].name);
        }
      }
      collision_week_data.collision_weeks.push({
        first_day: collision_weeks[i].first_day,
        selected_takt_start_week_days: selected,
        blocked_takt_start_week_days: [],
      });
    }
    // Promise.all([
    //   axios({
    //     url: 'projects/' + id,
    //     method: 'PUT',
    //     data: calendar_data,
    //     }),
    //   axios({
    //     url: 'projects/' + id + '/freedays/createbulk',
    //     method: 'POST',
    //     data: free_day_data,
    //   }),
    //   axios({
    //     url: 'projects/' + id + '/collisionweeks/createbulk',
    //     method: 'POST',
    //     data: collision_week_data,
    //   }),
    // ])
    axios({
      url: 'projects/' + id,
      method: 'PUT',
      data: calendar_data,
    })
    .then(() => {
      axios({
          url: 'projects/' + id + '/freedays/createbulk',
          method: 'POST',
          data: free_day_data,
      })
      .then(() => {
        axios({
              url: 'projects/' + id + '/collisionweeks/createbulk',
              method: 'POST',
              data: collision_week_data,
        })
        .then(() => {
          axios({
                url: 'projects/' + id + '/calendarlookup',
                method: 'POST',
                data: {dates: getters.getCalendar(id).takt_times}
          })
          .then(() => {
              router.push({name: 'ProjectTaktPlan'});
          })
          .catch(err4 => {
            commit('set_error', extractErrorDetails(err4));
          });
        })
        .catch(err3 => {
          commit('set_error', extractErrorDetails(err3));
        });
      })
      .catch(err2 => {
        commit('set_error', extractErrorDetails(err2));
      });
    })
    .catch(err1 => {
      commit('set_error', extractErrorDetails(err1));
    });
    // .then(() => {
    //   // commit('View/set_show_side_bar', false, {root: true});
    //   axios({
    //     url: 'projects/' + id + '/calendarlookup',
    //     method: 'POST',
    //     data: {dates: getters.getCalendar(id).takt_times}
    //   })
    //   .then(() => {
    //     router.push({name: 'ProjectTaktPlan'});
    //   })
    //   .catch(err2 => {
    //     commit('set_error', extractErrorDetails(err2));
    //   });
    // })
    // .catch(err => {
    //   commit('set_error', extractErrorDetails(err));
    // });
  },
  updateCalenderLookup({commit, getters}, project_id){
    return new Promise((resolve, reject) => {
      axios({
        url: 'projects/' + project_id + '/calendarlookup',
        method: 'POST',
        data: {dates: getters.getCalendar(project_id).takt_times}
      })
      .then(() => {
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        reject();
      });
    });
  },
  updateCalenderLookupForCopyProject({commit, getters}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: 'projects/' + payload.new_project_id + '/calendarlookup',
        method: 'POST',
        data: {dates: getters.getCalendar(payload.old_project_id).takt_times}
      })
      .then(() => {
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        reject();
      });
    });
  },
  // with Local mutation mutating ultra store
  deleteFreeDay({commit, getters, rootState}, payload) {
    payload.first_day_of_week_integer = getters.getFirstDayOfWeekInteger(payload.id);
    commit('delete_free_day', {rootState, payload});
    commit('check_collision_weeks', {getters, rootState, payload});
  },
  resetCalendar({commit, rootState}, project_id) {
    axios({
        url: 'projects/' + project_id + '?show=showForCalendar',
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(response => {
        let payload = {
          project_id: project_id,
          data: response.data.data,
        };
        commit('reset_calendar', {rootState, payload});
        // commit('View/set_show_side_bar', false, {root: true});
        router.push({name: 'ProjectTaktPlan'});
      });
  },
  setDayCollisionWeek({commit, rootState}, payload) {
    if (rootState.Ultra.projects[payload.id].collision_weeks.find(week => week.first_day === payload.first_day)[`collision_week_selected_${payload.day.name.toLowerCase()}`]) {
      payload.value = false;
    } else {
      payload.value = true;
    }
    commit('set_day_collision_week', {rootState, payload});
  },
  setFirstDayOfWeek({commit, getters, rootState}, payload) {
    commit('set_first_day_of_week', {rootState, payload});
    payload.first_day_of_week_integer = getters.getFirstDayOfWeekInteger(payload.id);
    commit('delete_collision_weeks', {rootState, payload});
    commit('check_collision_weeks', {getters, rootState, payload});
  },
  setFreeDay({commit, getters, rootState}, payload) {
    payload.first_day_of_week_integer = getters.getFirstDayOfWeekInteger(payload.id);
    commit('set_free_day', {rootState, payload});
    commit('check_collision_weeks', {getters, rootState, payload});
  },
  setProjectStart({commit, rootState}, payload) {
    commit('set_project_start', {rootState, payload});
  },
  setShowCalendarWeeks({commit, rootState}) {
    commit('set_show_calendar_weeks');
    if (state.show_calendar_weeks) {
      commit('ProjectStatistics/set_statistic_settings_cache', null, {root: true});
      commit('ProjectStatistics/set_statistic_settings', {setting: 'value', value: 'calendar'}, {root: true});
    } else if (rootState.ProjectStatistics.statistic_settings.value === 'calendar') {
      commit('ProjectStatistics/set_statistic_settings', {setting: 'value', value: rootState.ProjectStatistics.statistic_settings_cache.value}, {root: true});
    }
  },
  setTaktTime({commit, rootState}, payload) {
    commit('set_takt_time', {rootState, payload});
    commit('delete_collision_weeks', {rootState, payload});
  },
  setTaktStart({commit, getters, rootState}, payload) {
    payload.takt_day_selector = getters.getRegularWeek(payload.id);
    payload.first_day_of_week_integer = getters.getFirstDayOfWeekInteger(payload.id);
    if (rootState.Ultra.projects[payload.id][`calendar_selected_takt_start_week_days_${payload.takt_start.name.toLowerCase()}`]) {
      commit('clear_takt_start', {getters, rootState, payload});
      commit('delete_collision_weeks', {rootState, payload});
      commit('check_collision_weeks', {getters, rootState, payload});
    } else if (!rootState.Ultra.projects[payload.id][`calendar_blocked_takt_start_week_days_${payload.takt_start.name.toLowerCase()}`]) {
      commit('set_takt_start', {rootState, payload});
      commit('check_collision_weeks', {getters, rootState, payload});
    }
  },
  setWorkingTime({commit}, payload) {
    console.log(payload);
    commit('set_working_time', payload)
  }
};
// Mutations
const mutations = {
  //local state mutation
  set_show_calendar_weeks(state) {
    state.show_calendar_weeks = !state.show_calendar_weeks;
  },
  //ultraStore state mutation
  delete_free_day(state, {rootState, payload}) {
    let index = rootState.Ultra.projects[payload.id].free_days.findIndex(day => day.date.substring(0, 10) === payload.date);
    rootState.Ultra.projects[payload.id].free_days.splice(index, 1);
  },
  check_collision_weeks(state, {getters, rootState, payload}) {
    var first_day_date_string_array = [];
    for (let i = 0; i < rootState.Ultra.projects[payload.id].free_days.length; i++) {
      //Check Collision Weeks
      let free_day_date = getters.getNewDate(rootState.Ultra.projects[payload.id].free_days[i].date);

      let offset = free_day_date.getDay() - payload.first_day_of_week_integer;
      if (offset < 0) {
        offset = offset + 7;
      }
      let first_day_date = getters.getNewDate(free_day_date);
      first_day_date.setDate(free_day_date.getDate() - offset);
      let first_day_date_string = first_day_date.toISOString().substring(0, 10) + " 12:00:00 UTC";
      first_day_date_string_array.push(first_day_date_string);

      let collision = false;
      if (rootState.Ultra.projects[payload.id][`calendar_selected_takt_start_week_days_${rootState.Ultra.week_days[free_day_date.getDay()].toLowerCase()}`] ||
          rootState.Ultra.projects[payload.id][`calendar_blocked_takt_start_week_days_${rootState.Ultra.week_days[free_day_date.getDay()].toLowerCase()}`]
      ) {
        collision = true;
      }
      if (!rootState.Ultra.projects[payload.id].collision_weeks.find(week => week.first_day === first_day_date_string) && collision) {
        rootState.Ultra.projects[payload.id].collision_weeks.push({
          first_day: first_day_date_string,
          collision_week_selected_su: false,
          collision_week_selected_mo: false,
          collision_week_selected_tu: false,
          collision_week_selected_we: false,
          collision_week_selected_th: false,
          collision_week_selected_fr: false,
          collision_week_selected_sa: false,
          collision_week_blocked_su: false,
          collision_week_blocked_mo: false,
          collision_week_blocked_tu: false,
          collision_week_blocked_we: false,
          collision_week_blocked_th: false,
          collision_week_blocked_fr: false,
          collision_week_blocked_sa: false,
        });
      }
    }
    // check if collision week need to be deleted
    for (let i = 0; i < rootState.Ultra.projects[payload.id].collision_weeks.length; i++) {
      if (!first_day_date_string_array.includes(rootState.Ultra.projects[payload.id].collision_weeks[i].first_day)) {
        rootState.Ultra.projects[payload.id].collision_weeks.splice(i, 1);
      }
    }
  },
  clear_takt_start(state, {getters, rootState, payload}) {
    Vue.set(rootState.Ultra.projects[payload.id], `calendar_selected_takt_start_week_days_${payload.takt_start.name.toLowerCase()}`, false);
    for (let i = 0; i < rootState.Ultra.projects[payload.id].takt_time_value-1; i++) {
      let j = payload.takt_day_selector.findIndex(day => day.name === payload.takt_start.name) + i +1;
      if (j > payload.takt_day_selector.length-1) {
        j = j - payload.takt_day_selector.length;
      }
      Vue.set(rootState.Ultra.projects[payload.id], `calendar_blocked_takt_start_week_days_${payload.takt_day_selector[j].name.toLowerCase()}`, false);
    }
    if (rootState.Ultra.week_days.indexOf(payload.takt_start.name) === getters.getNewDate(rootState.Ultra.projects[payload.id].calendar_project_start).getDay()) {
      Vue.set(rootState.Ultra.projects[payload.id], 'calendar_project_start', '');
    }
  },
  delete_collision_weeks(state, {rootState, payload}) {
    Vue.set(rootState.Ultra.projects[payload.id], 'collision_weeks', []);
  },
  reset_calendar(state, {rootState, payload}) {
    for(const prop in payload.data) {
      Vue.set(rootState.Ultra.projects[payload.project_id], `${prop}`, payload.data[prop]);
    }
  },
  set_day_collision_week(state, {rootState, payload}) {
    Vue.set(rootState.Ultra.projects[payload.id].collision_weeks.find(week => week.first_day === payload.first_day), `collision_week_selected_${payload.day.name.toLowerCase()}`, payload.value);
  },
  set_first_day_of_week(state, {rootState, payload}) {
    if (rootState.Ultra.projects[payload.id].calendar_first_day_of_week !== payload.first_day_of_week) {
    Vue.set(rootState.Ultra.projects[payload.id], 'calendar_project_start', '');

    rootState.Ultra.projects[payload.id].calendar_selected_takt_start_week_days_su = false;
    rootState.Ultra.projects[payload.id].calendar_selected_takt_start_week_days_mo = false;
    rootState.Ultra.projects[payload.id].calendar_selected_takt_start_week_days_tu = false;
    rootState.Ultra.projects[payload.id].calendar_selected_takt_start_week_days_we = false;
    rootState.Ultra.projects[payload.id].calendar_selected_takt_start_week_days_th = false;
    rootState.Ultra.projects[payload.id].calendar_selected_takt_start_week_days_fr = false;
    rootState.Ultra.projects[payload.id].calendar_selected_takt_start_week_days_sa = false;

    rootState.Ultra.projects[payload.id].calendar_blocked_takt_start_week_days_su = false;
    rootState.Ultra.projects[payload.id].calendar_blocked_takt_start_week_days_mo = false;
    rootState.Ultra.projects[payload.id].calendar_blocked_takt_start_week_days_tu = false;
    rootState.Ultra.projects[payload.id].calendar_blocked_takt_start_week_days_we = false;
    rootState.Ultra.projects[payload.id].calendar_blocked_takt_start_week_days_th = false;
    rootState.Ultra.projects[payload.id].calendar_blocked_takt_start_week_days_fr = false;
    rootState.Ultra.projects[payload.id].calendar_blocked_takt_start_week_days_sa = false;
    }
    Vue.set(rootState.Ultra.projects[payload.id], 'calendar_first_day_of_week', payload.first_day_of_week);
  },
  set_free_day(state, {rootState, payload}) {
    //Clear Free Days Array
    rootState.Ultra.projects[payload.id].free_days.splice(0, rootState.Ultra.projects[payload.id].free_days.length);
    for (let i = 0; i < payload.dates.length; i++) {
      // Add Free Days Selection
      let date = payload.dates[i] + " 12:00:00 UTC";
      rootState.Ultra.projects[payload.id].free_days.push({date: date});
    }
  },
  set_project_start(state, {rootState, payload}) {
    if (payload.project_start === null) {
      Vue.set(rootState.Ultra.projects[payload.id], 'calendar_project_start', '');
    } else {
      Vue.set(rootState.Ultra.projects[payload.id], 'calendar_project_start', payload.project_start + " 12:00:00 UTC");
    }
  },
  set_takt_time(state, {rootState, payload}) {
    if (rootState.Ultra.projects[payload.id].takt_time_value !== payload.takt_time_value) {
    Vue.set(rootState.Ultra.projects[payload.id], 'calendar_project_start', '');

    rootState.Ultra.projects[payload.id].calendar_selected_takt_start_week_days_su = false;
    rootState.Ultra.projects[payload.id].calendar_selected_takt_start_week_days_mo = false;
    rootState.Ultra.projects[payload.id].calendar_selected_takt_start_week_days_tu = false;
    rootState.Ultra.projects[payload.id].calendar_selected_takt_start_week_days_we = false;
    rootState.Ultra.projects[payload.id].calendar_selected_takt_start_week_days_th = false;
    rootState.Ultra.projects[payload.id].calendar_selected_takt_start_week_days_fr = false;
    rootState.Ultra.projects[payload.id].calendar_selected_takt_start_week_days_sa = false;

    rootState.Ultra.projects[payload.id].calendar_blocked_takt_start_week_days_su = false;
    rootState.Ultra.projects[payload.id].calendar_blocked_takt_start_week_days_mo = false;
    rootState.Ultra.projects[payload.id].calendar_blocked_takt_start_week_days_tu = false;
    rootState.Ultra.projects[payload.id].calendar_blocked_takt_start_week_days_we = false;
    rootState.Ultra.projects[payload.id].calendar_blocked_takt_start_week_days_th = false;
    rootState.Ultra.projects[payload.id].calendar_blocked_takt_start_week_days_fr = false;
    rootState.Ultra.projects[payload.id].calendar_blocked_takt_start_week_days_sa = false;
    }
    Vue.set(rootState.Ultra.projects[payload.id], 'takt_time_value', payload.takt_time_value);
  },
  set_takt_start(state, {rootState, payload}) {
    let takt_start_valid = true;
    for (let i = 0; i < rootState.Ultra.projects[payload.id].takt_time_value; i++) {
      let j = payload.takt_day_selector.findIndex(day => day.name === payload.takt_start.name) + i;
      if (j > payload.takt_day_selector.length-1) {
        j = j - payload.takt_day_selector.length;
      }
      if (payload.takt_day_selector[j].selected || payload.takt_day_selector[j].blocked) {
        takt_start_valid = false;
      }
    }
    if (takt_start_valid) {
    Vue.set(rootState.Ultra.projects[payload.id], `calendar_selected_takt_start_week_days_${payload.takt_start.name.toLowerCase()}`, true);
    for (let i = 0; i < rootState.Ultra.projects[payload.id].takt_time_value-1; i++) {
      let j = payload.takt_day_selector.findIndex(day => day.name === payload.takt_start.name) + i +1;
      if (j > payload.takt_day_selector.length-1) {
        j = j - payload.takt_day_selector.length;
      }
      Vue.set(rootState.Ultra.projects[payload.id], `calendar_blocked_takt_start_week_days_${payload.takt_day_selector[j].name.toLowerCase()}`, true);
    }
  }
  },
  set_working_time(state, payload) {
    state.working_time = payload
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
